import { type UseQueryOptions, useQuery } from "@tanstack/react-query";

import type { DTO } from "@equidefi/shared/types";
import OfferingClient from "../clients/OfferingClient";
import { type ApiClientClass, useApi } from "./useApi";

export const PLATFORM_SETTINGS_QUERY_KEY = ["platformSettings"] as const;

export const usePlatformSettings = (options: UseQueryOptions<DTO.PlatformSetting | null> = {}) => {
  const offeringApi = useApi(OfferingClient as unknown as ApiClientClass<OfferingClient>);

  return useQuery<DTO.PlatformSetting | null>(
    PLATFORM_SETTINGS_QUERY_KEY,
    () => offeringApi.getPlatformSettings(),
    options,
  );
};
